import Swal from 'sweetalert2';

async function confirmarAlert({ opcoes = {}, confirmar = () => {}, cancelar = () => {}, titulo = '', mensagem = '' }) {
  const result = await Swal.fire({
    reverseButtons: true,
    title: titulo,
    text: mensagem,
    icon: 'warning',
    showCancelButton: true,
    cancelButtonColor: '#d33',
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não',
    allowOutsideClick: false,
    ...opcoes,
  });
  if (result.value) {
    confirmar(result);
  } else {
    cancelar(result);
  }
}

export default confirmarAlert;
